module.exports = __webpack_public_path__ + "media/img/pwpush-logo-52b3dd7c6074325669001684ca6ee4fd.png";